import { DocumentVersion } from "./document-version.model";
import { DocumentCodeList } from "./document-code-list";
import { DocumentAttributeValue } from "./document-attribute-value.model";

export class DocumentCard {
    DocumentId: number;
    Number: string;
    Name: string;
    DocumentCategoryId: number;
    DocumentTypeId: number;
    Description: string;
    DocumentStatusId: number;
    Text: string;
    UpdateDateToString: string;
    UpdateByToString: string;

    TranslationLanguageId?: number;
    DocumentTranslations: DocumentTranslation[];
    DocumentTagIds: number[];
    DocumentVersions: DocumentVersion[];
    CurrentDocumentVersion: DocumentVersion;
    DocumentCodeLists: DocumentCodeList[];
    DocumentAttributeValues: DocumentAttributeValue[];

    SelectedDepartments: number[];
    SelectedEquipments: number[];
    SelectedWorkstationResources: number[];

    original_Name: string;
    original_Description: string;

    constructor() {
      this.DocumentTagIds = [];
      this.DocumentVersions = [];
      this.CurrentDocumentVersion = new DocumentVersion();
      this.DocumentCodeLists = [];
      this.DocumentAttributeValues = [];
    }
}

export class DocumentTranslation {
  DocumentId: number;
  LanguageId: number;
  Number: string;//Should be removed??
  Name: string;
  Description: string;
  TranslationLanguageId: number;
  LanguageCode: string;
  LanguageDescription: string;
}
